module.exports = __webpack_public_path__ + "static/media/login.42754253.svg";